import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Progress18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_669)'>
      <path
        d='M16.25 9C16.25 4.99594 13.0041 1.75 9.00003 1.75C8.51487 1.75 8.04157 1.79755 7.58428 1.88801L7.29318 0.416531C7.84582 0.307202 8.41661 0.25 9.00003 0.25C13.8325 0.25 17.75 4.16751 17.75 9C17.75 13.8325 13.8325 17.75 9.00003 17.75C8.41661 17.75 7.84582 17.6928 7.29318 17.5835L7.58428 16.112C8.04157 16.2025 8.51487 16.25 9.00003 16.25C13.0041 16.25 16.25 13.0041 16.25 9Z'
        fill='currentColor'
      />
      <path
        d='M4.13786 16.2757C3.18399 15.6371 2.36288 14.816 1.72428 13.8622L2.97073 13.0277C3.50026 13.8186 4.1814 14.4998 4.97234 15.0293L4.13786 16.2757Z'
        fill='currentColor'
      />
      <path
        d='M1.72428 4.13784C2.36288 3.18396 3.18398 2.36285 4.13786 1.72425L4.97234 2.9707C4.18139 3.50023 3.50025 4.18137 2.97073 4.97231L1.72428 4.13784Z'
        fill='currentColor'
      />
      <path
        d='M0.416557 7.29315L1.88804 7.58426C1.70711 8.49883 1.70711 9.50117 1.88804 10.4157L0.416557 10.7068C0.197899 9.60156 0.197899 8.39843 0.416557 7.29315Z'
        fill='currentColor'
      />
      <path
        d='M8.5322 12.0928L13.0606 6.99829L11.9395 6.00174L8.46797 9.90724L7.03041 8.46968L5.96975 9.53034L8.5322 12.0928Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_669'>
        <rect
          width='18'
          height='18'
          fill='white'
          transform='matrix(0 1 -1 0 18 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Progress18.displayName = 'Progress18';
export default Progress18;
